import React, { useEffect, useState } from "react";
import { Table, Typography, Button, Row } from "antd";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

function Project() {

const navigate = useNavigate();
const [projects, setProjects] = useState([]);

useEffect(() => {


const token = localStorage.getItem("access-token");

fetch("https://rhrmapi.up2dateinc.com/api/projects", {
  headers: {
    Authorization: `Bearer ${token}`
  }
})
  .then(res => res.json())
  .then(data => {
    if (Array.isArray(data)) {
      setProjects(data);
    } else {
      setProjects([]);
    }
  })
  .catch(err => {
    console.log(err);
    setProjects([]);
  });

}, []);

const columns = [
{
title: "SL No",
render: (_, __, index) => index + 1,
},
{
title: "Project Name",
dataIndex: "projectName",
},
{
title: "Client Name",
dataIndex: "client",
},
{
title: "Project Lead",
dataIndex: "projectLead",
},
{
title: "Approximate Tasks",
dataIndex: "tasks",
},
{
title: "Start Date",
dataIndex: "startDate",
},
{
title: "End Date",
dataIndex: "endDate",
},
{
title: "Sprint Start",
dataIndex: "sprintStart",
},
{
title: "Project Duration",
dataIndex: "duration",
render: (text) => `${text} days`,
},
{
title: "Status",
dataIndex: "status",
},
];

return (
<div>

<Row justify="space-between" align="middle">
<Title level={3}>Projects</Title>

<div>

<Button
type="primary"
style={{ marginRight: 10 }}
onClick={() => navigate("/admin/add-project")}
>
Add Project
</Button>

<Button onClick={() => navigate("/admin/manage-project")}>
Manage Project
</Button>

</div>
</Row>

<Table
rowKey="_id"
columns={columns}
dataSource={Array.isArray(projects) ? projects : []}
pagination={{ pageSize: 5 }}
style={{ marginTop: 20 }}
/>

</div>
);
}

export default Project;